"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newCatalogFact = exports.CatalogFactBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var groupFactory_1 = require("./groupFactory");
var builder_1 = require("../builder");
var factFactory_1 = require("../metadata/factFactory");
/**
 * Catalog fact builder
 * See {@link Builder}
 *
 * @beta
 */
var CatalogFactBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(CatalogFactBuilder, _super);
    function CatalogFactBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogFactBuilder.prototype.fact = function (factOrRef, modifications) {
        if (!sdk_backend_spi_1.isFactMetadataObject(factOrRef)) {
            this.item.fact = factFactory_1.newFactMetadataObject(factOrRef, modifications);
        }
        else {
            this.item.fact = factOrRef;
        }
        return this;
    };
    return CatalogFactBuilder;
}(groupFactory_1.GroupableCatalogItemBuilder));
exports.CatalogFactBuilder = CatalogFactBuilder;
/**
 * Catalog fact factory
 *
 * @param modifications - catalog fact builder modifications to perform
 * @returns created catalog fact
 * @beta
 */
exports.newCatalogFact = function (modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    return builder_1.builderFactory(CatalogFactBuilder, { type: "fact" }, modifications);
};
//# sourceMappingURL=factFactory.js.map